/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
document.addEventListener('DOMContentLoaded', function() {

  let subGiftButtons = document.querySelectorAll(".givy_send_as_gift_button");
  subGiftButtons.forEach(button => {
    const variantId = button.dataset.variantId; 
    const planId = button.dataset.planId; 
    button.addEventListener('click', function(e) {
      e.preventDefault();
      GIVY.displayModal(variantId, {
         displaySubscriptionOptions: true,
         initialSelectedSellingPlanId:planId 
      });
    });

  });

  
}); 



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
